
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phone/debut",
      function () {
        return require("private-next-pages/phone/debut/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/phone/debut"])
      });
    }
  